'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Divider, Stack, Typography } from '@mui/material';
import { LabelsEditor } from '@/components/labels/labelsEditor';
import { RenameEntityName } from '@/components/wizard/renameEntityName';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';

/**
 * The policy name with its labels alongside. Labels are authored here rather than in a step of
 * their own because they describe the policy as a whole, not any one step's settings. Edits land
 * in the wizard's state as they are made, like the rest of the wizard: the step's own Save Changes
 * is what commits them.
 */
export const PolicyNameAndLabels = t0 => {
  const $ = _c(12);
  const {
    name,
    labels,
    focusOnName,
    onNameChange,
    onLabelsChange
  } = t0;
  const {
    PolicyAndVaultMetadataLabels: t1
  } = useFeatureFlags();
  const PolicyAndVaultMetadataLabels = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: "16px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== focusOnName || $[2] !== name || $[3] !== onNameChange) {
    t3 = <RenameEntityName focusOnMount={focusOnName} label="Backup policy name" name={name} onSubmit={onNameChange} />;
    $[1] = focusOnName;
    $[2] = name;
    $[3] = onNameChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== PolicyAndVaultMetadataLabels || $[6] !== labels || $[7] !== onLabelsChange) {
    t4 = PolicyAndVaultMetadataLabels && <><Divider orientation="vertical" flexItem={true} sx={{
        height: "20px",
        alignSelf: "center"
      }} /><Stack direction="row" sx={{
        alignItems: "center",
        gap: "8px"
      }}><Typography>Labels</Typography><Box sx={{
          minWidth: 0,
          maxWidth: "600px"
        }}><LabelsEditor labels={labels} onChange={onLabelsChange} /></Box></Stack></>;
    $[5] = PolicyAndVaultMetadataLabels;
    $[6] = labels;
    $[7] = onLabelsChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Stack direction="row" sx={t2}>{t3}{t4}</Stack>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};